<lib-notification
  [(show)]="notificationService.showMessage"
  [message]="notificationService.Message"
></lib-notification>
@if(showHeader){
<app-header></app-header>
}
@if (!this.userService.currentUser && !this.isWatermanager) {
  <div
    class="googleBtnContainer"
    >
    @if (!currentUser) {
      <asl-google-signin-button
        type="standard"
        size="large"
      ></asl-google-signin-button>
    }
  </div>
}
@if (this.userService.currentUser || this.isWatermanager) {
  <router-outlet />
}
